import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CircleCheckBig } from 'lucide-react';
import { Button } from '@/components/ui-kit/button';
import { useResendActivation } from '@/modules/auth/hooks/use-auth';
import { LOGIN_COLORS } from '@/modules/auth/constants/login-theme';

const emailSentIcon = '/assets/images/verification-failed.svg';

export const VerificationFailed = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId');
  const { mutateAsync: resendActivation, isPending } = useResendActivation();
  const [isResendSuccess, setIsResendSuccess] = useState(false);

  const handleResendActivation = async () => {
    if (!userId) return;
    try {
      await resendActivation({
        userId,
        projectKey: import.meta.env.VITE_X_BLOCKS_KEY || '',
      });
      setIsResendSuccess(true);
    } catch (error) {
      setIsResendSuccess(false);
      console.error('Failed to resend activation link:', error);
    }
  };

  return (
    <div className="flex w-full flex-col gap-8">
      <div className="flex justify-center">
        <img src={emailSentIcon} alt="" className="h-14 w-14" />
      </div>

      <div className="flex flex-col gap-3">
        <h2
          className="break-words text-[2rem] font-bold leading-tight tracking-tight sm:text-[2.125rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('VERIFICATION_FAILED')}
        </h2>
        <p className="text-sm font-normal leading-5" style={{ color: LOGIN_COLORS.textMuted }}>
          {t('VERIFICATION_EMAIL_NO_LONGER_VALID')}
        </p>
      </div>
      {userId && (
        <Button
          className="h-12 w-full rounded-xl border-0 text-sm font-semibold shadow-none hover:opacity-90"
          size="lg"
          onClick={handleResendActivation}
          disabled={isPending}
          style={{ backgroundColor: LOGIN_COLORS.primary, color: LOGIN_COLORS.pureWhite }}
        >
          {isPending ? t('SENDING...') : t('RESEND_LINK')}
        </Button>
      )}
      <Button
        className="h-12 w-full rounded-xl border-0 text-sm font-semibold shadow-none"
        size="lg"
        variant="ghost"
        onClick={() => navigate('/login')}
        style={{ color: LOGIN_COLORS.primary }}
      >
        {t('GO_TO_LOGIN')}
      </Button>

      {isResendSuccess && (
        <div className="flex items-center gap-2 mt-2">
          <CircleCheckBig className="shrink-0 text-success" size={20} />
          <span className="text-sm font-medium text-success">
            {t('RESET_PASSWORD_LINK_SENT_EMAIL')}
            {/* it says A link has been sent successfully */}
          </span>
        </div>
      )}
    </div>
  );
};
